import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Accordion as BSAccordion, Container } from 'react-bootstrap';
import { avatars } from '../Avatar/AvatarDemo';
import AvatarGroup, {
  AvatarGroupSize,
  AvatarGroupStyle,
} from '../Avatar/AvatarGroup';
import Button from '../Button';
import Accordion from './Accordion';
import AccordionBodyItem from './AccordionBodyItem';

const AccordionDemo = () => {
  return (
    <Container>
      <Container>
        <h4>Accordion with Info Icon</h4>
        <Accordion
          title={'Health Benefits'}
          subtitle={'Short one-line additional infomation here'}
          infoIcon={light('circle-exclamation')}
        >
          <AccordionBodyItem
            title={'Medical'}
            subtitle={'HMO Plan'}
            infoIcon={light('heart-pulse')}
            price={'$210.55'}
            isOriginalPriceShown
            isHint
            originalPrice={'$210.55'}
            priceStyleType={'default'}
            infoButton={
              <Button size="sm" variant="primary-outline">
                Plan Details
              </Button>
            }
            changeButton={
              <Button size="sm" variant="primary">
                Change
              </Button>
            }
            avatarGroup={
              <AvatarGroup
                avatars={avatars}
                groupSize={AvatarGroupSize.MINIMIZED}
                groupStyle={AvatarGroupStyle.STACKED}
              />
            }
          />
        </Accordion>
      </Container>
      <Container>
        <h4>Accordion without Info Icon</h4>
        <Accordion
          title={'Spending Accounts'}
          subtitle={'Short one-line additional information here'}
        >
          <AccordionBodyItem
            infoIcon={light('heart-pulse')}
            title={'Medical'}
            subtitle={'HMO Plan'}
            price={'$210.55'}
            priceStyleType={'disabled'}
            avatarGroup={
              <AvatarGroup
                avatars={avatars}
                groupSize={AvatarGroupSize.MINIMIZED}
                groupStyle={AvatarGroupStyle.STACKED}
              />
            }
          />
        </Accordion>
      </Container>
      <Container>
        <h4>Default Boostrap Accordion</h4>
        <BSAccordion defaultActiveKey="0" className="bs-accordion">
          <BSAccordion.Item eventKey="0">
            <BSAccordion.Header className="bs-accordion-header">
              BSAccordion Item #1
            </BSAccordion.Header>
            <BSAccordion.Body>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur. Excepteur sint occaecat cupidatat non proident,
              sunt in culpa qui officia deserunt mollit anim id est laborum.
            </BSAccordion.Body>
          </BSAccordion.Item>
        </BSAccordion>
      </Container>
    </Container>
  );
};

export default AccordionDemo;
